(() => {
  if (!document.body.classList.contains('collection')) return;
  const watchedImages = new WeakSet();
  const prepareSecondaryImages = () => {
    document.querySelectorAll('.boost-pfs-filter-products .image-element__wrap img.secondary').forEach(image => {
      if (watchedImages.has(image)) return;
      watchedImages.add(image);
      const layer = image.closest('.image-element__wrap');
      const ready = () => layer.classList.toggle('yw-secondary-ready', image.complete && image.naturalWidth > 1 && !!image.currentSrc && !image.currentSrc.startsWith('data:'));
      image.addEventListener('load', ready);
      image.addEventListener('error', () => layer.classList.remove('yw-secondary-ready'));
      ready();
    });
  };
  const refresh = () => {
    prepareSecondaryImages();
    prepareGroups();
    document.querySelectorAll('.boost-pfs-filter-option-range-amount-wrapper').forEach(wrapper => {
      const input = wrapper.querySelector('input');
      if (!input || wrapper.querySelector('.yw-price-label')) return;
      const key = input.classList.contains('boost-pfs-filter-option-range-amount-min') ? 'yw_min_price' : 'yw_max_price';
      const label = document.createElement('span');
      label.className = 'yw-price-label';
      label.textContent = window.boostPFSThemeConfig?.label?.[key] || input.getAttribute('aria-label');
      label.setAttribute('aria-hidden', 'true');
      wrapper.prepend(label);
      input.setAttribute('inputmode', 'decimal');
      input.setAttribute('aria-label', label.textContent);
    });
    const label = window.boostPFSThemeConfig?.label?.yw_filters;
    document.querySelectorAll('.boost-pfs-filter-tree-mobile-button button').forEach(button => {
      if (!label) return;
      button.setAttribute('aria-label', label);
      const text = button.querySelector('.boost-pfs-filter-tree-mobile-button-label');
      if (text && text.textContent !== label) text.textContent = label;
    });
    document.querySelectorAll('.boost-pfs-filter-option-item button[role="checkbox"]').forEach(button => {
      const checked = button.closest('.boost-pfs-filter-option-item').classList.contains('selected');
      button.setAttribute('aria-checked', String(checked));
      const child = button.querySelector('.boost-pfs-check-box');
      if (child) {
        child.removeAttribute('role');
        child.removeAttribute('tabindex');
        child.removeAttribute('aria-labelledby');
        child.setAttribute('aria-hidden', 'true');
      }
    });
  };
  let frame;
  const update = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = null; refresh(); });
  };
  // The filter column sticks just below the fixed header, whatever height the header is at this screen size
  const sidebar = document.querySelector('.yw-filter-sidebar');
  const header = document.querySelector('.header');
  let stickyFrame;
  const placeSidebar = () => {
    stickyFrame = null;
    if (!sidebar || !header) return;
    const bottom = getComputedStyle(header).position === 'fixed' || getComputedStyle(header).position === 'sticky' ? header.getBoundingClientRect().bottom : 0;
    sidebar.style.setProperty('--yw-sticky-top', `${Math.max(16, Math.round(bottom) + 16)}px`);
  };
  const queueSidebar = () => { if (!stickyFrame) stickyFrame = requestAnimationFrame(placeSidebar); };
  // Filter groups in the column start closed with just their names showing; the ones a shopper opens stay open when
  // Boost redraws the filters after each change. Long lists show their first 8 options and a Show all link.
  const openGroups = new Set();
  const fullLists = new Set();
  const SHOW = 8;
  const groupKey = option => [...option.classList].find(name => name.startsWith('boost-pfs-filter-option-') && !/-(list|swatch|range|box|collapsed|column|style)/.test(name) && name !== 'boost-pfs-filter-option-item');
  const labels = window.boostPFSThemeConfig?.label || {};
  const prepareGroups = () => {
    if (!sidebar) return;
    sidebar.querySelectorAll('.boost-pfs-filter-option').forEach(option => {
      const key = groupKey(option);
      const open = openGroups.has(key);
      option.classList.toggle('yw-open', open);
      option.querySelector('.boost-pfs-filter-option-title-heading')?.setAttribute('aria-expanded', String(open));
      const list = option.querySelector('.boost-pfs-filter-option-item-list');
      const count = list ? list.children.length : 0;
      let more = option.querySelector('.yw-show-all');
      if (count <= SHOW) { more?.remove(); list?.classList.remove('yw-clipped'); return; }
      const full = fullLists.has(key);
      list.classList.toggle('yw-clipped', !full);
      if (!more) {
        more = document.createElement('button');
        more.type = 'button';
        more.className = 'yw-show-all';
        list.after(more);
      }
      more.dataset.group = key;
      more.setAttribute('aria-expanded', String(full));
      more.textContent = full ? (labels.yw_show_fewer || 'Show fewer') : (labels.yw_show_all || 'Show all (__COUNT__)').replace('__COUNT__', count);
    });
  };
  sidebar?.addEventListener('click', event => {
    const heading = event.target.closest('.boost-pfs-filter-option-title-heading');
    if (heading) {
      // Handled here rather than by Boost, so the open/closed state is ours to keep
      event.preventDefault();
      event.stopPropagation();
      const key = groupKey(heading.closest('.boost-pfs-filter-option'));
      if (openGroups.has(key)) openGroups.delete(key); else openGroups.add(key);
      prepareGroups();
      return;
    }
    const more = event.target.closest('.yw-show-all');
    if (more) {
      if (fullLists.has(more.dataset.group)) fullLists.delete(more.dataset.group); else fullLists.add(more.dataset.group);
      prepareGroups();
      return;
    }
    const sortHeading = event.target.closest('.yw-sort-group__heading');
    if (sortHeading) {
      const options = sidebar.querySelector('.yw-sort-group__options');
      const open = sortHeading.getAttribute('aria-expanded') !== 'true';
      sortHeading.setAttribute('aria-expanded', String(open));
      options.hidden = !open;
    }
  }, true);
  window.addEventListener('scroll', queueSidebar, { passive: true });
  window.addEventListener('resize', queueSidebar);
  placeSidebar();
  const main = document.querySelector('.yw-collection');
  if (main) new MutationObserver(update).observe(main, { childList: true, subtree: true });
  refresh();
  document.addEventListener('click', event => {
    const button = event.target.closest('.yw-description-toggle');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const content = button.closest('.collectionDescription');
    const expanded = button.classList.contains('showAll');
    content.querySelector('.halfcontent').style.display = expanded ? 'none' : 'block';
    content.querySelector('.fullcontent').style.display = expanded ? 'block' : 'none';
    content.querySelector('.showAll').style.display = expanded ? 'none' : 'inline-block';
    content.querySelector('.showLess').style.display = expanded ? 'inline-block' : 'none';
    content.querySelector(expanded ? '.showLess' : '.showAll').focus({ preventScroll: true });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('.boost-pfs-filter-tree-h .boost-pfs-filter-option-title-heading[aria-expanded="true"]');
    if (open) { open.click(); open.focus(); }
  });
})();


